import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { ApproveClusterNodeRequest, IApproveClusterNodeParams } from '../requests/ApproveClusterNodeRequest';
import { AssignClusterToPoolRequest, IAssignClusterToPoolParams } from '../requests/AssignClusterToPoolRequest';
import { CreateBaasClusterRequest, ICreateBaasClusterParams } from '../requests/CreateBaasClusterRequest';
import { CreateBaasEdgePoolRequest, ICreateBaasEdgePoolParams } from '../requests/CreateBaasEdgePoolRequest';
import { DeleteBaasClusterRequest, IDeleteBaasClusterParams } from '../requests/DeleteBaasClusterRequest';
import { DeleteBaasEdgePoolRequest, IDeleteBaasEdgePoolParams } from '../requests/DeleteBaasEdgePoolRequest';
import { DeleteClusterNodeRequest, IDeleteClusterNodeParams } from '../requests/DeleteClusterNodeRequest';
import { IDownloadScriptParams } from '../requests/DownloadScript';
import { FetchAllClusterstRequest, IFetchAllClustersParams } from '../requests/FetchAllClusterstRequest';
import { GetBaasClusterDetailsRequest, IGetBaasClusterDetailsParams } from '../requests/GetBaasClusterDetailsRequest';
import { GetBaasEdgePoolsRequest, IGetBaasEdgePoolsAndClustersParams } from '../requests/GetBaasEdgePoolsAndClustersRequest';
import { GetDockerRegistryRequest, IGetDockerRegistryParams } from '../requests/GetDockerRegistryRequest';
import { IRefreshBaseImageParams, RefreshBaseImageRequest } from '../requests/RefreshBaseImageRequest';
import { IRejectPoolNodeParams, RejectPoolNodeRequest } from '../requests/RejectPoolNodeRequest';
import { IShareClusterToTenantSitesParams, ShareClusterToTenantSitesRequest } from '../requests/ShareClusterToTenantSites';
import { IUpdateBaasClusterNameParams, UpdateBaasClusterNameRequest } from '../requests/UpdateBaasClusterNameRequest';
import { IUpdateBaasEdgePoolParams, UpdateBaasEdgePoolRequest } from '../requests/UpdateBaasEdgePoolRequest';
import { IUpdateBaasPoolServiceTokensParams, UpdateBaasPoolServiceTokensRequest } from '../requests/UpdateBaasPoolServiceTokensRequest';

export namespace BaasEdgePoolAndCluster {

  export function createBaasCluster(params: ICreateBaasClusterParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateBaasClusterRequest({ ...params }));
  }

  export function createBaasPool(params: ICreateBaasEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateBaasEdgePoolRequest({ ...params }));
  }

  export function getBaasPoolsAndCluster(params: IGetBaasEdgePoolsAndClustersParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetBaasEdgePoolsRequest({ ...params }));
  }

  export function deleteBaasPools(params: IDeleteBaasEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeleteBaasEdgePoolRequest({ ...params }));
  }

  export function deleteBaasCluster(params: IDeleteBaasClusterParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeleteBaasClusterRequest({ ...params }));
  }

  export function updateBaasPool(params: IUpdateBaasEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateBaasEdgePoolRequest({ ...params }));
  }

  export function updateBaasClusterName(params: IUpdateBaasClusterNameParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateBaasClusterNameRequest({ ...params }));
  }

  export function approveClusterNode(params: IApproveClusterNodeParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new ApproveClusterNodeRequest({ ...params }));
  }

  export function updateBaasPoolServiceTokens(params: IUpdateBaasPoolServiceTokensParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateBaasPoolServiceTokensRequest({ ...params }));
  }

  export function refreshBaseImage(params: IRefreshBaseImageParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new RefreshBaseImageRequest({ ...params }));
  }

  export function getBaasClusterDetails(params: IGetBaasClusterDetailsParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetBaasClusterDetailsRequest({ ...params }));
  }

  export function rejectPoolNode(params: IRejectPoolNodeParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new RejectPoolNodeRequest({ ...params }));
  }

  export function deleteClusterNode(params: IDeleteClusterNodeParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeleteClusterNodeRequest({ ...params }));
  }

  export function getDockerRegistry(params: IGetDockerRegistryParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetDockerRegistryRequest({ ...params }));
  }

  export function fetchAllClusters(params: IFetchAllClustersParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new FetchAllClusterstRequest({ ...params }));
  }
  export function assignClusterToPool(params: IAssignClusterToPoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new AssignClusterToPoolRequest({ ...params }));
  }

  export function shareClusterToTenantSites(params: IShareClusterToTenantSitesParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new ShareClusterToTenantSitesRequest({ ...params }));
  }

  export function downloadScript(params: IDownloadScriptParams): Promise<IResult> {
    WindowLocationService.download(WebHttpClient.FILE_UPLOAD_API_PREFIX+'baas/'+params.clusterId+'/onboardNodeFile');
    return Promise.resolve({});
  }
}
